import { statusOrderLang } from '~/constants/statusOrder';

const useCheckStatusOrder = (value) => statusOrderLang.find((item) => item.value === value);

export default useCheckStatusOrder;
